<template>
  <div :class="{ 'light-mode': lightMode }">
    <div v-if="loadingCycleChart" class="loading-container">
      <img
        v-if="partnerView"
        src="@shared/assets/img/general/loading.svg"
        alt="Loading"
        class="loader-img"
      />
      <img
        v-else
        src="@shared/assets/img/general/loading-white.svg"
        alt="Loading"
        class="loader-img"
      />
    </div>
    <div v-else>
      <div v-if="Object.keys(cycleChartData).length">
        <CycleChart
          ref="cycleChart"
          :lightMode="lightMode"
          :legend-visibility-state="legendVisibilityState"
          @legend-visibility-changed="onLegendVisibilityChanged"
        />
      </div>
      <div v-else class="no-graph">No cycle data..</div>
    </div>
  </div>
</template>

<script>
import CycleChart from '@shared/components/deviceDetail/cycleChart/CycleChart.vue';
import deviceDetailMixin from '@shared/mixins/deviceDetailMixin';

export default {
  name: 'CycleChartIndex',
  components: { CycleChart },
  mixins: [deviceDetailMixin],
  props: {
    lightMode: Boolean,
  },
  data() {
    return {
      // State to persist legend visibility across chart re-renders
      legendVisibilityState: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    onLegendVisibilityChanged(event) {
      // Update the parent's legend visibility state
      this.legendVisibilityState = { ...event.visibilityState };

      // You can also emit this to a higher-level parent if needed
      this.$emit('legend-visibility-changed', event);
    },
    resetLegendVisibility() {
      // Reset legend visibility state
      this.legendVisibilityState = {};

      // Reset the chart's legend visibility if it exists
      if (this.$refs.cycleChart && this.$refs.cycleChart.resetLegendVisibility) {
        this.$refs.cycleChart.resetLegendVisibility();
      }
    },
    getLegendVisibilityState() {
      // Get current legend visibility state
      return { ...this.legendVisibilityState };
    },
    setLegendVisibilityState(state) {
      // Set legend visibility state from external source
      this.legendVisibilityState = { ...state };

      // Apply to chart if it exists
      if (this.$refs.cycleChart && this.$refs.cycleChart.setLegendVisibilityState) {
        this.$refs.cycleChart.setLegendVisibilityState(state);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  display: grid;
  justify-content: center;
  align-items: center;
}
.no-graph {
  display: grid;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.3px;
  height: 200px;
  color: var(--text-color);
  margin-top: 20px;
  border-radius: 8px;
}
</style>
